import React, { useState, useEffect } from "react";
import { connect } from 'react-redux'
import { makeStyles } from "@material-ui/styles";
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, Typography, Button, TablePagination, Box, Paper, CardContent, Modal, IconButton, TextField, FormControl, Card } from "@mui/material";
import { CircularProgress } from "@material-ui/core";
import * as Action from "../../actions/adminAction"
import Image1 from "../../Assets/Image/satara_Mandave.JPG"
import Image2 from "../../Assets/Image/satara_Mandave_2.jpg"
import { useLocation, useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { BASE_URL } from "../../utils/urls";
import { ArrowBack } from "@mui/icons-material";
require('../../App.css')


export const RolloutDetailsDC = ({ userDetails }) => {

    const classes = useStyles()
    const navigate = useNavigate()
    const location = useLocation()
    const Trainer = location.state
    const [gramData, setGramData] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getGramData()

    }, [])
    
    const getGramData = () => {
        setLoader(true);
        const url = BASE_URL + "/school/getschoolsinglelist";
        let header = new Headers();
        header.append("Content-Type", "application/x-www-form-urlencoded")
        let urlencoded = new URLSearchParams();
        urlencoded.append("grampanchayat_id", Trainer?.grampanchayat_id);
        const opt = {
            method: 'POST',
            headers: header,
            body: urlencoded,
        }
        fetch(url, opt)
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                }
                else {
                    alert("Error While Getting School Data");
                }
            })
            .then(data => {
                // console.log("GramData,", data)
                data !== undefined && data !== null && data !== "No data found" && setGramData(data)
                setLoader(false);
            })
            .catch(err => { alert("Error catched While getting Gram Data");  })
    }



    if (loader)
        return (<div className={classes.main}>
            <CircularProgress color="success" />
        </div>)

    return (
        <div className={classes.main}>
            <Card className={classes.card} style={{ backgroundColor: 'whitesmoke' }}>
                <div style={{ backgroundColor: '#1d5a96', display: 'flex', flexDirection: 'row', width: '100%', margin: 0 }}>
                    <IconButton style={{ margin: 10, padding: 0 }}>
                        <Typography style={{ fontFamily: 'sans-serif', fontWeight: 700, color: 'white', fontSize: 24, backgroundColor: '#1d5a96' }} sx={{
                        }} ><ArrowBack style={{marginRight:'10px', fontSize: 30, cursor:'pointer'}} onClick={() => navigate(-1)}/>Plan Details</Typography>
                    </IconButton>
                </div>
                <div>
                    <Table>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Assignment Date:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? dayjs(Trainer.startDate,).format("DD/MM/YYYY") : '-'}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>District:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.districtName : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>School:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.grampanchayatName : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Module:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainingModuleName : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Timing:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer?.shift? Trainer?.shift?.toUpperCase():'-' : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Trainer:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainerNameAll[0]: "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Trainer Mobile:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainerMobileAll[0]: "-"}</TableCell>
                        </TableRow>
                    
                    </Table>
                </div>
                {/* <center>
                    <Button variant="contained" style={{ margin: 20 }} onClick={() => navigate(-1)}>Back</Button>
                </center> */}
            </Card>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: 'column',
        marginTop: 30
    },
    card: {
        width: '100%',
        borderRadius: '20px !important',
        margin: '20px',
        padding: '20px',
    },
    passmodal: {
        width: '350px',
        background: 'white',
        borderRadius: '20px !important',
        margin: '20px',
        padding: '20px',
    },
    profilemodal: {
        width: '1000px',
        background: 'white',
        borderRadius: '20px !important',
        margin: '20px',
        padding: '20px',
    },
    middlePosition: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    input: {
        width: '70%',
        background: 'white',
        marginTop: '20px',
        padding: '5px 15px'
    },
    image: {
        width: 150,
        height: 150
    },
    imageApprove: {
        backgroundColor: 'green',
        color: 'white'
    },
    imageReject: {
        backgroundColor: 'red',
        color: 'white'
    }
}));

const mapStateToProps = (state) => {
    return {
        userDetails: state.auth.userDetails,
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RolloutDetailsDC)